export default {
  products: [],
  products_io: [],
}
